"use client";
import * as React from "react";
const SvgShoppingCartRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M4.8 12.8a1.6 1.6 0 1 0 .01 3.2 1.6 1.6 0 0 0-.01-3.2M0 0v1.6h1.6l2.88 6.07L3.4 9.63q-.2.35-.2.77c0 .88.72 1.6 1.6 1.6h9.6v-1.6H5.14a.2.2 0 0 1-.2-.2l.02-.1.72-1.3h5.96c.6 0 1.13-.33 1.4-.82l2.86-5.2a.8.8 0 0 0-.7-1.18H3.37L2.62 0zm12.8 12.8a1.6 1.6 0 1 0 .01 3.2 1.6 1.6 0 0 0-.01-3.2" }));
export {
  SvgShoppingCartRound as default
};
